import { render, staticRenderFns } from "./subjectChart.vue?vue&type=template&id=1756b3b0&"
import script from "./subjectChart.vue?vue&type=script&lang=js&"
export * from "./subjectChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports